/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../../utility/Constant";

const CertificateContentPage = () => {
  const { certificateApi } = apiPath;
  const { clientCertificate } = clientSideUrl;
  const [certificateContentData, certificateContentLoading] =
    useFetch(certificateApi);

  if (certificateContentLoading) {
    return <Loading />;
  }

  const { description, title, _id } = certificateContentData[0];

  const data = [
    {
      elementType: "input",
      label: "Banner Subtitle",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "textField",
      label: "banner description",
      type: "Text",
      name: "description",
      defaultValue: description,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(certificateApi, data, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-blue-600 hover:text-blue-500"
          to={clientCertificate}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <h1 className="font-oswald font-bold text-2xl md:-mb-10 uppercase">
        banner content
      </h1>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default CertificateContentPage;
